<script setup>
import { ref } from "@vue/reactivity";
import Nav from "./components/Nav.vue";
let Darkmode = ref(true);
function mode() {
 Darkmode.value = !Darkmode.value;
}
</script>
<template>
 <div :class="{ dark: Darkmode }">
  <Nav :dark="Darkmode" @dmode="mode" />
  <router-view />
 </div>
</template>
